import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withFormikField, getFormikError } from 'utils/formik';
import { Checkbox, Flexer, Field } from '@ontruck/orc';

const t = {
  label: 'Temperature',
  help: 'ºC',
  to: 'to',
};

const TemperatureExtra = ({ field, form }) => {
  const { value } = field;
  const { setFieldValue } = form;

  const hasTemperature = !!value;
  const { min, max } = value || {};
  return (
    <Flexer.Parent alignItems="center">
      <Flexer.Child>
        <Checkbox
          label={t.label}
          size="M"
          girded
          checked={hasTemperature}
          onChange={(e, { value }) =>
            setFieldValue(field.name, value ? { min: '', max: '' } : null)
          }
        />
      </Flexer.Child>
      {hasTemperature && (
        <Fragment>
          <Flexer.Child mLeft="S">
            <Field
              value={min || ''}
              labelType="hidden"
              width="XS"
              asideRightText={t.help}
              onChange={(e, { value }) => {
                setFieldValue(field.name, { max, min: value });
              }}
              invalid={!!getFormikError({ field: { name: `${field.name}.min` }, form })}
            />
          </Flexer.Child>
          <Flexer.Child mLeft="XS" mRight="XS">
            {t.to}
          </Flexer.Child>
          <Flexer.Child>
            <Field
              value={max || ''}
              labelType="hidden"
              width="XS"
              asideRightText={t.help}
              onChange={(e, { value }) => {
                setFieldValue(field.name, { min, max: value });
              }}
              invalid={!!getFormikError({ field: { name: `${field.name}.max` }, form })}
            />
          </Flexer.Child>
        </Fragment>
      )}
    </Flexer.Parent>
  );
};

TemperatureExtra.propTypes = {
  field: PropTypes.object,
  form: PropTypes.object,
};

export default withFormikField(TemperatureExtra);
